import { render, staticRenderFns } from "./BehaviorStatList.vue?vue&type=template&id=ba4c6bd6&scoped=true"
import script from "./BehaviorStatList.vue?vue&type=script&lang=js"
export * from "./BehaviorStatList.vue?vue&type=script&lang=js"
import style0 from "./BehaviorStatList.vue?vue&type=style&index=0&id=ba4c6bd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4c6bd6",
  null
  
)

export default component.exports